import { IconClock } from '@tabler/icons-react';
import usePreSaleVisitFeedback from '../hooks/usePreSaleVisitFeedback';

// Etiqueta "Feedback Proper" pendiente en las asesorías finalizadas que aún no
// tienen feedback (sólo aparece cuando falta).
const PreSaleFeedbackPill = ({
  visitId,
  pending,
}: {
  visitId: string;
  // Si el padre ya sabe si falta feedback, se evita el GET por fila.
  pending?: boolean;
}) => {
  const { state } = usePreSaleVisitFeedback(visitId, pending === undefined);
  if (pending === undefined ? state !== 'pending' : !pending) return null;
  return (
    <span className="dv2-fb-pill">
      <IconClock size={12} /> Feedback Proper
    </span>
  );
};

export default PreSaleFeedbackPill;
